const styles = {
  buttonGroup: {
    height: 110,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 4,
    margin: 0,
  },
  counterButtons: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 0,
    width: '100%',
  },
  raiseButtons: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 0,
    width: '100%',
  },
  button: {
    backgroundColor: 'gray',
    border: 'none',
    borderRadius: 2,
    boxShadow: 'none',
    color: 'white',
    margin: 0,
    padding: 2,
    width: '100%',
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: `sans-serif, 'Open Sans', helvetica`,
    fontSize: '1em',
    fontWeight: 'normal',
  },
  active: {
    button: '#ff9521', // orange | backgroundColor
  },
  complete: {
    button: '#28A745' , // green | backgroundColor
  }
};

export default styles;
